import { trackEvent } from '../../../_common/client/tracking';
import { isFoldable } from './is-foldable';

export function initializeExpandButton(rootElement: HTMLElement) {
    const expandButton = rootElement.querySelector<HTMLElement>('.js_pdp_short-info__expand-button');
    const shortInfoRight = rootElement.querySelector<HTMLElement>('.js_pdp_short-info__right');
    const subHeadingElement = rootElement.querySelector<HTMLElement>('.js_pdp_short-info__subheading');
    if (!expandButton || !subHeadingElement || !isFoldable(subHeadingElement) || !shortInfoRight) return;
    shortInfoRight.classList.remove('pl_hidden');
    expandButton.addEventListener('click', () => {
        subHeadingElement.style.maxHeight = 'none';
        expandButton.classList.add('pl_hidden');
        trackEvent({ product_ShortInfo: 'more' });
    });
}
